"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcText = function ArcText(_ref) {
  var label = _ref.label,
    type = _ref.type,
    disabled = _ref.disabled,
    mark = _ref.mark,
    code = _ref.code,
    keyboard = _ref.keyboard,
    underline = _ref.underline,
    strong = _ref.strong,
    italic = _ref.italic,
    deletep = _ref.deletep,
    linkedtext = _ref.linkedtext,
    href = _ref.href,
    editable = _ref.editable,
    copyable = _ref.copyable;
  var Text = _lib.Typography.Text,
    Link = _lib.Typography.Link;
  return !linkedtext ? /*#__PURE__*/_react["default"].createElement(Text, {
    type: type && type,
    disabled: disabled,
    mark: mark,
    code: code,
    keyboard: keyboard,
    underline: underline,
    strong: strong,
    italic: italic,
    "delete": deletep,
    editable: editable,
    copyable: copyable
  }, label) : /*#__PURE__*/_react["default"].createElement(Link, {
    editable: editable,
    href: href ? href : "/",
    copyable: copyable,
    underline: underline
  }, label);
};
var _default = ArcText;
exports["default"] = _default;